import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { UiState } from "./types";

const initialState: UiState = {
  subscriptionExpired: false,
};

export const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    setSubscriptionExpired: (state, action: PayloadAction<boolean>) => {
      state.subscriptionExpired = action.payload;
    },
  },
});

export default uiSlice.reducer;
export const { setSubscriptionExpired } = uiSlice.actions;
